/*eslint-disable*/
import React from "react";
import { Container, Row } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer mt-4" + (this.props.default ? " footer-default" : "")}
        style={{ position: 'relative', width: '100%', padding: 0, color: '#789', textDecoration: 'none', paddingRight: '6%', paddingLeft: '6%', }}
      >
        {/* <div fluid={this.props.fluid ? true : false}> */}
        <div className="d-flex" style={{ justifyContent: 'space-between' }}>
          <nav className="footer-nav">
            <ul>
              <li >
                <a href="http://www.pezhman.tech" target="_blank">Rhino Ver 0.5</a>
              </li>
              {/* <li>
                  <a href="https://blog.creative-tim.com" target="_blank">Blog</a>
                </li>
                <li>
                  <a href="https://www.creative-tim.com/license" target="_blank">Licenses</a>
                </li> */}
            </ul>
          </nav>
          <div className="credits">
            <div className="copyright">
              <a href="http://www.pezhman.tech" target="_blank" style={{ color: '#789', textDecoration: 'none' }}>
                <p> &copy; {1900 + new Date().getYear()}, Designed by White Rhino Group</p>
              </a>
            </div>
          </div>
        </div>
        {/* </div> */}
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool
};

export default Footer;
